import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {Modal, Button, FormControl} from "react-bootstrap";

import {DISPATCH_MAIN_MODAL_HIDE, DISPATCH_MODAL_DEPOSIT_DRIVER, showDepositModalDrivers} from "../../actions/modal";
import {act_loadDepositDriver, driverDepositUnlock} from "../../actions/deposit_driver";
import {DepositDriver} from "../Deposit/DepositDriver";
import {stateToCenterId} from "../../../../utils/center";
import "../../css/DepositModal.css";

class InternalModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUnlockModal: false,
      unlockReason: '',
      submittingUnlock: false
    };
    this.handleUnlockClick = this.handleUnlockClick.bind(this);
    this.handleUnlockConfirm = this.handleUnlockConfirm.bind(this);
    this.handleUnlockCancel = this.handleUnlockCancel.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Ne recharger que si le driver a changé, pas à chaque changement d'état
    const currentDriverId = this.props.modal && this.props.modal.driver ? this.props.modal.driver.id : null;
    const prevDriverId = prevProps.modal && prevProps.modal.driver ? prevProps.modal.driver.id : null;

    if (currentDriverId && currentDriverId !== prevDriverId) {
      this.props.loadDepositDriver(currentDriverId);
    }
  }
  componentDidMount() {
    const {modal} = this.props;

    if (!modal.driver) {
      return null;
    }

    const driver = modal.driver;
    this.props.loadDepositDriver(driver.id);
  }

  handleUnlockClick() {
    this.setState({ showUnlockModal: true, unlockReason: '' });
  }

  async handleUnlockConfirm() {
    const { modal, unlockDriver, currentCenterId } = this.props;
    const { unlockReason, submittingUnlock } = this.state;

    if (submittingUnlock) return;

    this.setState({ submittingUnlock: true });
    try {
      await unlockDriver(modal.driver.id, currentCenterId, unlockReason);
      this.setState({ showUnlockModal: false, unlockReason: '', submittingUnlock: false });
    } catch (error) {
      this.setState({ submittingUnlock: false });
    }
  }

  handleUnlockCancel() {
    this.setState({ showUnlockModal: false, unlockReason: '' });
  }

  render() {
    const {modal, hide, goToDepositDrivers, centers, currentCenterId} = this.props;
    const { showUnlockModal, unlockReason, submittingUnlock } = this.state;

    if (!modal.driver) {
      return null;
    }
    const driver = modal.driver;

    // Vérifier si la fonctionnalité est activée pour ce centre
    const currentCenter = centers.find(c => c.id === currentCenterId);
    const isPreventDlgAttributionIfConsigneToReturn = currentCenter && currentCenter.prevent_dlg_attribution_if_consigne_to_return === true;
    return (
      <>
        <Modal
          show={modal && modal.modalType === DISPATCH_MODAL_DEPOSIT_DRIVER}
          animation={false}
          backdrop={true}
          onHide={() => hide()}
          keyboard={true}
          className="DepositModalDriver"
          enforceFocus={false}
        >
          <Modal.Body>
            <button className="btn btn-default btn-xs" onClick={() => goToDepositDrivers()}>
              <i className="fa-solid fa-chevron-left"></i> Retour &agrave; la liste des consignes
            </button>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
              <h4 style={{ margin: 0 }}>Consignes {driver.name}</h4>
              {isPreventDlgAttributionIfConsigneToReturn && (
                <Button
                  bsStyle="info"
                  bsSize="xs"
                  onClick={this.handleUnlockClick}
                  className="btn-info"
                >
                  Débloquer (auj)
                </Button>
              )}
            </div>
            <DepositDriver driver={driver} />
          </Modal.Body>
        </Modal>

        {/* Modal de déblocage */}
        <Modal show={showUnlockModal} onHide={this.handleUnlockCancel}>
          <Modal.Body>
            <button type="button" className="close" onClick={this.handleUnlockCancel}>&times;</button>
            <div className="form-group">
              <label>Raison du déblocage (facultatif)</label>
              <FormControl
                componentClass="textarea"
                rows={3}
                value={unlockReason}
                onChange={(e) => this.setState({ unlockReason: e.target.value })}
                placeholder="Ex: Urgence, besoin de livreurs, retour prévu plus tard..."
              />
              <p className="help-block text-muted">
                Le déblocage sera valide jusqu'à 2h du matin. Le livreur pourra accepter de nouvelles tournées malgré ses dettes de consignes.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleUnlockCancel} variant="outline-secondary" disabled={submittingUnlock}>Annuler</Button>
            <Button variant="primary" onClick={this.handleUnlockConfirm} disabled={submittingUnlock}>
              {submittingUnlock ? 'Déblocage en cours...' : 'Confirmer le déblocage'}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

InternalModal.propTypes = {
  driver: PropTypes.object,
  modal: PropTypes.object.isRequired,
  hide: PropTypes.func.isRequired,
  loadDepositDriver: PropTypes.func.isRequired,
  goToDepositDrivers: PropTypes.func.isRequired,
  unlockDriver: PropTypes.func.isRequired,
  currentCenterId: PropTypes.number.isRequired,
  centers: PropTypes.array.isRequired,
};

export const DepositModalDriver = connect(
  (state) => {
    return {
      "modal" : state.dispatch.modal,
      "currentCenterId": stateToCenterId(state),
      "centers": state.dispatch.metas.centers || [],
    };
  },
  (dispatch) => {
    return {
      "hide": () => {
        dispatch({"type": DISPATCH_MAIN_MODAL_HIDE});
      },
      loadDepositDriver: (id) => dispatch(act_loadDepositDriver(id)),
      goToDepositDrivers: () =>  dispatch(showDepositModalDrivers()),
      unlockDriver: (driverId, centerId, reason) => dispatch(driverDepositUnlock(driverId, centerId, reason)),
    };
  }
)(InternalModal);
